import { compact } from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import { MIN_CHAR_SEARCH } from 'redux/constants';

import CircleButton from 'elements/CircleButton';

import SearchIcon from './SearchIcon';

// A simple magnifying glass in a circle. Clicking it expands the search bar.
function SearchButton({ expanded, onClick, performSearch, searchValue }) {
  const closedAndActive = !expanded;
  const openAndDisabled = searchValue.length <= MIN_CHAR_SEARCH && expanded;
  const openAndActive = searchValue.length > MIN_CHAR_SEARCH && expanded;

  return (
    <CircleButton
      disabled={openAndDisabled}
      id="search-button"
      modifiers={compact([openAndDisabled && 'disabled'])}
      onClick={() => {
        if (closedAndActive) {
          return onClick();
        } else if (openAndActive) {
          return performSearch();
        }
        return null;
      }}
    >
      <SearchIcon name="search" modifiers={compact([openAndDisabled && 'disabled'])} />
    </CircleButton>
  );
}

SearchButton.propTypes = {
  expanded: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  performSearch: PropTypes.func.isRequired,
  searchValue: PropTypes.string.isRequired,
};

export default SearchButton;



// WEBPACK FOOTER //
// ./components/Search/SearchButton/index.js